module.exports = __webpack_public_path__ + "static/media/swing.d4e99ca6.mov";